<template>
  <el-row class="warp">
    <el-col
      :span="24"
      class="warp-main"
      v-loading="loading"
      element-loading-text="拼命加载中"
    >
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
        <el-form :inline="true" :model="filters" ref="searchForm">
          <el-form-item>
            <el-input
              v-model="filters.name"
              placeholder="项目名称"
              style="min-width: 340px"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button type="primary" @click="searchReset">重置</el-button>
          <el-button type="primary" @click="showAddDialog">添加项目</el-button>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table :data="projectList" highlight-current-row border>
        <el-table-column
          type="index"
          label="序号"
          width="60"
          align="center"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="项目名称"
          align="center"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="provinceName"
          label="省"
          align="center"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="cityName"
          label="市"
          align="center"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="districtName"
          label="区"
          align="center"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="addressDetail"
          label="地址"
          align="center"
          width="360"
        ></el-table-column>
        <el-table-column
          prop="createDate"
          label="创建时间"
          align="center"
          width="160"
        ></el-table-column>

        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="showEditDialog(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="remove(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>

      <!-- 未绑定项目 -->
      <el-dialog
        :title="bind.title"
        :visible.sync="bind.visible"
        :close-on-click-modal="false"
        width="80%"
        top="5vh"
      >
        <el-row>
          <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
            <el-form :model="bind.searchForm" :inline="true">
              <el-form-item label="项目名称">
                <el-input
                  v-model="bind.searchForm.projectName"
                  placeholder="项目名称"
                  style="width: 320px"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  style="margin: 5px 0px 5px 5px; padding: 5px; font-size: 12px"
                  @click="bindSearch"
                  >查询</el-button
                >
                <el-button
                  type="primary"
                  style="margin: 5px 0px 5px 5px; padding: 5px; font-size: 12px"
                  @click="noBindResetForm()"
                  >重置</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-table
              :data="bind.dataList"
              highlight-current-row
              border
              lazy
              ref="multipleTable"
              @selection-change="handleSelectionChange"
              :row-key="rowkey"
            >
              <el-table-column
                type="selection"
                width="55"
                :reserve-selection="true"
              ></el-table-column>
              <el-table-column
                prop="deviceName"
                label="设备名称"
                align="center"
                fixed="left"
              ></el-table-column>
              <el-table-column
                prop="deviceCode"
                label="设备编号"
                align="center"
                width="160"
              ></el-table-column>
              <el-table-column
                prop="deviceShortcode"
                label="设备短号"
                align="center"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="deviceSn"
                label="设备型号"
                align="center"
                width="220"
              ></el-table-column>
              <el-table-column
                prop="deviceSupplierCategoryName"
                label="设备类别"
                align="center"
                width="280"
              ></el-table-column>
              <el-table-column
                prop="deviceSupplierName"
                label="供应商"
                align="center"
                width="280"
              ></el-table-column>
              <el-table-column
                prop="projectName"
                label="项目"
                align="center"
                width="160"
              ></el-table-column>
              <el-table-column
                prop="deviceState"
                label="设备状态"
                align="center"
                width="160"
              ></el-table-column>
            </el-table>
            <!--工具条-->
            <el-col :span="24" class="toolbar">
              <el-pagination
                @size-change="bindhandleSizeChange"
                @current-change="bindhandleCurrentChange"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="bind.total"
                style="float: right"
              >
              </el-pagination>
            </el-col>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="bind.visible = false">取消</el-button>
          <el-button type="primary" @click.native="bindSure" :loading="loading"
            >确定</el-button
          >
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>

<script>
import API from "../../api/third/project";
export default {
  components: { Event },
  props: {
    platformId: { type: String, default: null },
    openflg: { type: Number, default: -1 }
  },
  data() {
    return {
      loading: false,
      projectList: [],
      total: 0,
      page: 1,
      limit: 10,
      //条件
      filters: {
        name: undefined,
        code: undefined
      },
      //绑定界面
      bind: {
        title: "未绑定项目",
        visible: false,
        searchForm: {},
        dataList: []
      }
    };
  },
  watch: {},
  methods: {
    //重置
    searchReset: function () {
      this.filters = {};
      this.$refs.searchForm.resetFields();
    },
    //获取平台数据
    search: function () {
      let that = this;
      let params = {
        page: that.page,
        limit: that.limit,
        platformId: that.platformId,
        projectName: that.filters.name ? that.filters.name : undefined
      };

      that.loading = true;
      API.getList(params)
        .then(
          function (result) {
            that.loading = false;
            console.log(result);
            if (result && result.code == 200) {
              that.total = result.data.total;
              that.projectList = result.data.records;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    handleSizeChange(val) {
      this.limit = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    handleSearch() {
      this.total = 0;
      this.page = 1;
      this.search();
    },
    //添加
    showAddDialog() {
      let that = this;
      that.bind.dataList = [];
      that.bind.visible = true;

      that.bindSearch();
    },

    //删除
    remove(index, row) {
      let that = this;
      this.$confirm("确认删除该记录吗?", "提示", { type: "warning" })
        .then(() => {
          that.loading = true;
          API.delete(row.interId)
            .then(
              function (result) {
                that.loading = false;
                if (result && result.code === 200) {
                  that.$message.success({
                    showClose: true,
                    message: "删除成功",
                    duration: 1500
                  });
                  that.search();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.msg,
                    duration: 1500
                  });
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
    },
    //未绑定设备查询
    bindSearch() {
      let that = this;
      let params = that.bind.searchForm;
      params.page = that.bind.page;
      params.limit = that.bind.limit;
      (platformId = that.platformId),
        (projectName = that.filters.name ? that.filters.name : undefined);
      API.bindList(params)
        .then(
          function (result) {
            that.loading = false;
            console.log(result);
            if (result && result.code == 200) {
              that.bind.total = result.data.total;
              that.bind.tableList = result.data.records;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    }
  },
  mounted() {
    this.handleSearch();
    this.event.dataList = [];
    this.interList = [];
  },
  watch: {
    openflg() {
      this.handleSearch();
      this.event.dataList = [];
      this.interList = [];
    }
  }
};
</script>



// WEBPACK FOOTER //
// project.vue?7bf9cd41